import axios from "axios";
import {
  addBranchUrl,
  branchDataUrl,
  branchProductPaymentInfoUrl,
  updateFormDataUrl,
  branchProductsUrl,
  checkBranchDataStatus,
  getBranchDetailUrl,
  getBranchNamesUrl,
  getBranchesUrl,
  postBranchDataUrl,
  getTeamListUrl,
  deleteTeamDataUrl,
  updateTeamDataUrl,
  fetchBranchLogoUrl,
  branchProductPaymentInfoUrlNew,
} from "common/constants/apiUrls";
import {
  getData,
  postData,
  updateData,
  deleteData,
} from "networkManager/NetworkManager";

export const createBranch = (pathsId, payload) => {
  const { bankgroupsId, bankId } = pathsId;
  const url = addBranchUrl(bankgroupsId, bankId);
  return postData(url, payload);
};

export const getBranchList = (pathId, params) => {
  let {
    pageNumber = 1,
    pageSize = 10,
    searchString = "",
    orderBy = "",
    orderType = "",
    products,
  } = params;
  let productFilterString = "";
  products.forEach((el) => {
    productFilterString += `&ProductId=${el}`;
  });
  let paramsString = `?PageNumber=${pageNumber}&PageSize=${pageSize}&SearchString=${searchString}&OrderBy=${orderBy}&OrderType=${orderType}${productFilterString}`;
  const { bankgroupsId } = pathId;
  const url = `${getBranchesUrl(bankgroupsId)}${paramsString}`;
  return getData(url);
};

export const getBranchNames = (pathIds) => {
  const { bankgroupsId, bankId } = pathIds;
  const url = getBranchNamesUrl(bankgroupsId, bankId);
  return getData(url);
};

export const getBranchDetail = (pathId) => {
  const { bankgroupsId, bankId, branchId } = pathId;
  const url = getBranchDetailUrl(bankgroupsId, bankId, branchId);
  return getData(url);
};

export const updateBranchDetail = (pathIds, payload) => {
  const { bankgroupsId, bankId, branchId } = pathIds;
  const url = getBranchDetailUrl(bankgroupsId, bankId, branchId);
  return updateData(url, payload);
};

export const fetchBranchLogo = (imageURL) => {
  const url = fetchBranchLogoUrl(imageURL);
  return axios.get(url, { responseType: "blob" }).then((response) => {
    try {
      if (response.status === 200) {
        return response;
      }
    } catch (e) {
    }
  });
};
export const downloadDocument = (imageURL, downloadedFileName) => {
  const url = fetchBranchLogoUrl(imageURL);
  return axios.get(url, { responseType: "blob" }).then((response) => {
    try {
      if (response.status === 200) {
        const result = { status: 200 };
        const url = URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", downloadedFileName + ".pdf");
        document.body.appendChild(link);
        link.click();
        return result;
      }
    } catch (e) {
    }
  });
};

export const updateBranchProducts = (pathsId, payload) => {
  const { bankgroupsId, bankId, branchId } = pathsId;
  const url = branchProductsUrl(bankgroupsId, bankId, branchId);
  return updateData(url, payload);
};

export const getBranchProducts = (pathsId) => {
  const { bankgroupsId, bankId, branchId } = pathsId;
  const url = branchProductsUrl(bankgroupsId, bankId, branchId);
  return getData(url);
};

export const getBranchData = (pathsId) => {
  const { bankGroupId, bankId, branchId, productId } = pathsId;
  let url = branchDataUrl(bankGroupId, bankId, branchId, productId);
  return getData(url);
};

export const getFormData = (pathsId) => {
  const { bankGroupId, bankId, branchId, productId } = pathsId;
  let url = branchDataUrl(bankGroupId, bankId, branchId, productId);
  return getData(url);
};

export const getBranchProductPaymentInfo = (pathsId) => {
  const { bankGroupId, bankId, branchId, productId } = pathsId;
  const url = branchProductPaymentInfoUrl(
    bankGroupId,
    bankId,
    branchId,
    productId
  );
  return getData(url);
};
export const getBranchProductPaymentInfoNew = (pathsId) => {
  const { bankGroupId, bankId, branchId } = pathsId;
  const url = branchProductPaymentInfoUrlNew(
    bankGroupId,
    bankId,
    branchId,
  );
  return getData(url);
}
export const updateBranchProductPaymentInfo = (pathsId, payload) => {
  const { bankGroupId, bankId, branchId, productId } = pathsId;
  const url = branchProductPaymentInfoUrl(
    bankGroupId,
    bankId,
    branchId,
    productId
  );
  return updateData(url, payload);
};
export const updateBranchProductPaymentInfoNew = (pathsId, payload) => {
  const { bankGroupId, bankId, branchId } = pathsId;
  const url = branchProductPaymentInfoUrlNew(
    bankGroupId,
    bankId,
    branchId,
  );
  return postData(url, payload);
};
export const updateBranchData = (pathsId, queryParams, payload) => {
  const { bankGroupId, bankId, branchId, productId } = pathsId;
  let url = branchDataUrl(bankGroupId, bankId, branchId, productId);
  url = `${url}?${Object.entries(queryParams)
    .map(([key, val]) => `${key}=${val ?? ""}`)
    .join("&")}`;
  return updateData(url, payload);
};

export const getBranchDataStatus = (pathsId) => {
  const { bankGroupId, bankId, branchId } = pathsId;
  const url = checkBranchDataStatus(bankGroupId, bankId, branchId);
  return getData(url);
};

export const createBranchConsultant = (requestPayload, pathsId) => {
  const { bankGroupId, bankId, branchId, productId } = pathsId;
  let url = updateFormDataUrl(bankGroupId, bankId, branchId, productId);
  url = `${url}`;
  return postData(url, requestPayload);
};

export const getTeamList = (pathsId, filters, pageNumber) => {
  const { bankGroupId, bankId, branchId, productId } = pathsId;
  let { searchString, orderBy, filter, orderType } = filters;
  let url = getTeamListUrl(
    bankGroupId,
    bankId,
    branchId,
    productId,
    pageNumber
  );
  url = `${url}&SearchString=${searchString}&OrderBy=${orderBy}&Filter=${filter}&OrderType=${orderType}`;
  return getData(url);
};

export const deleteTeam = (pathsId, teamMemberId) => {
  const { bankGroupId, bankId, branchId, productId } = pathsId;
  let url = deleteTeamDataUrl(
    bankGroupId,
    bankId,
    branchId,
    productId,
    teamMemberId
  );
  return deleteData(url, "");
};

export const updateTeam = (pathIds, teamMemberId, dataFilters, payload) => {
  const { bankGroupId, bankId, branchId, productId } = pathIds;
  let { firstName, lastName, description, education } = dataFilters;
  let url = updateTeamDataUrl(
    bankGroupId,
    bankId,
    branchId,
    productId,
    teamMemberId
  );
  url = `${url}?FirstName=${firstName}&LastName=${lastName}&Description=${description}&Education=${education}`;
  return updateData(url, payload);
};
